query specialsLiabilityCompetitions($sportId: UUID!, $search: String) {
  allCompetitions(
    condition: { sportId: $sportId, limbo: false }
    orderBy: COMPETITION_NAME_ASC
    filter: { competitionName: { includesInsensitive: $search } }
  ) {
    nodes {
      sportId
      competitionId
      competitionName
    }
  }
}
